import { render, staticRenderFns } from "./ProSubscriptionExpansionPanel.vue?vue&type=template&id=748c3d7b"
import script from "./ProSubscriptionExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ProSubscriptionExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports